<div [class.container-fluid]="isStandalone" [class.sb-standalone-mode]="isStandalone">
    <section
        class="card"
        [class.sb-highlight-content]="(viewPortSize$ | async) !== 'xs' && showFilters"
    >
        <header
            class="card-header align-items-bottom pb-2 z-2"
            [class.sticky-header]="(scrollPosition$ | async) > 48"
        >
            <h3 class="mb-0">Market value & cash</h3>
            <div class="d-flex align-self-start mt-n3">
                <button
                    type="button"
                    class="btn btn-link me-n3 text-primary"
                    (click)="toggleShowFilters()"
                >
                    <tabler-icon name="adjustments-horizontal"></tabler-icon>
                    <sb-notification-badge
                        *ngIf="
                            (issuersCtrl.value
                                | sbFilterCount
                                    : (availableIssuers$ | async)
                                    : (isLoading$ | async)) +
                            (instrumentsCtrl.value
                                | sbFilterCount
                                    : (availableInstrumentIds$ | async)
                                    : (isLoading$ | async)) as numberOfFilters
                        "
                        [@fadeInOut]
                        [tooltip]="
                            numberOfFilters === 1
                                ? 'A filter has been applied to the list.'
                                : numberOfFilters +
                                  ' filters have been applied to the list.'
                        "
                        [numberOfNotifications]="numberOfFilters"
                        iconBadge="true"
                    ></sb-notification-badge>
                </button>
            </div>
        </header>
        <div class="card-body pt-0 pb-2">
            <sb-generic-type-select
                label="Group by"
                class="d-inline-block my-n1"
                [formControl]="dimensionCtrl"
                appearance="none"
                [valueKey]="false"
                [options]="dimensionOptions$ | async"
            ></sb-generic-type-select>
            <!--<sb-slide-toggle
                [options]="dimensionOptions$ | async"
                [formControl]="dimensionCtrl"
            ></sb-slide-toggle>-->
        </div>
        <div
            *ngIf="!(data$ | async)"
            class="table-loading skeleton-loader skeleton-loader-table m-3"
            aria-busy="true"
        >
            <span class="visually-hidden">Loading</span>
        </div>
        <div class="card-body pt-2 overflow-hidden" *ngIf="data$ | async as data">
            <ng-container *ngIf="data?.total > 0; else noAccounts">
                <dl
                    class="sb-item-list"
                    [@list]="currentPage$ | async"
                    (@list.start)="onAnimationStart($event)"
                    (@list.done)="onAnimationDone($event)"
                >
                    <ng-container
                        *ngFor="
                            let account of data.items;
                            trackBy: trackByFn;
                            let i = index
                        "
                    >
                        <div
                            @slideInOut
                            class="sb-list-item"
                            *ngIf="(activeDimension$ | async).value as dimension"
                            [class.sb-list-item-account]="dimension === 'accountId'"
                            [class.sb-list-item-first]="i === 0"
                            [style.--item-index]="i + 1"
                            [ngSwitch]="dimension"
                        >
                            <ng-container *ngSwitchCase="'accountId'">
                                <ng-content
                                    *ngTemplateOutlet="
                                        accountItem;
                                        context: { $implicit: account }
                                    "
                                ></ng-content>
                            </ng-container>
                            <ng-container *ngSwitchCase="'issuerId'">
                                <ng-content
                                    *ngTemplateOutlet="
                                        accountIssuerItem;
                                        context: { $implicit: account }
                                    "
                                ></ng-content>
                            </ng-container>
                            <ng-container *ngSwitchCase="'legalEntityId'">
                                <ng-content
                                    *ngTemplateOutlet="
                                        legalEntityItem;
                                        context: { $implicit: account }
                                    "
                                ></ng-content>
                            </ng-container>
                            <ng-container *ngSwitchDefault>
                                <ng-content
                                    *ngTemplateOutlet="
                                        tagGroupItem;
                                        context: { $implicit: account }
                                    "
                                ></ng-content>
                            </ng-container>
                        </div>
                    </ng-container>
                </dl>
                <mat-paginator
                    class="mt-n1 mb-n3"
                    *ngIf="data.total > 8"
                    hidePageSize="true"
                    [length]="data.total"
                    pageSize="8"
                    (page)="onPageChange($event)"
                    aria-label="Select page"
                    [disabled]="hasPendingAnimation$ | async"
                ></mat-paginator>
            </ng-container>
        </div>
    </section>
    <div
        [class.opacity-0]="(viewPortSize$ | async) === 'xs'"
        class="backdrop"
        (click)="toggleShowFilters()"
        *ngIf="showFilters"
        [@fadeInOut]
    ></div>
</div>
<ng-template #tagGroupItem let-tagGroup>
    <ng-container
        *ngIf="{
            map: tagGroupsMap$ | async,
            group: activeDimension$ | async
        } as tag"
    >
        <a
            [routerLink]="['/', 'sb-grid', 'portfolio-summary']"
            [queryParams]="{
                accountIds: tagGroup.entities | entityConcat : 'accountId',
                tagGroup: tag.group.value,
                tag: tagGroup.id
            }"
        >
            <ng-container
                *ngIf="
                    tag?.map &&
                        tag?.group?.value &&
                        tagGroup?.id &&
                        tag.map[tag.group.value] &&
                        tag.map[tag.group.value][tagGroup.id];
                    else notTagged
                "
            >
                <ng-container
                    *ngIf="tag?.map[tag?.group?.value][tagGroup?.id] as tagGroup"
                >
                    <sb-company-logo
                        size="lg"
                        class="sb-list-logo"
                        type="TAG"
                    ></sb-company-logo>
                    <dt class="sb-list-name">
                        {{ tagGroup?.title || 'Loading...' }}
                    </dt>
                    <dd class="sb-list-detail text-secondary small">
                        {{ tagGroup?.description }}
                    </dd>
                </ng-container>
            </ng-container>
            <ng-template #notTagged>
                <sb-company-logo
                    size="lg"
                    class="sb-list-logo"
                    [color]="{
                        foreground: 'var(--text-color)',
                        background: 'var(--text-muted-color)'
                    }"
                    type="NOT_SET"
                ></sb-company-logo>
                <dt class="sb-list-name">
                    {{ tagGroup?.id | translate }}
                </dt>
                <dd class="sb-list-detail text-secondary small">
                    Holdings where {{ tag.group.value | lowercase }} has not been set
                </dd>
            </ng-template>
            <dd class="sb-list-balance">
                <sb-animated-number
                    [ccy]="
                        (useBaseCurrency$ | async)
                            ? (baseCurrency$ | async)
                            : tagGroup.currency
                    "
                    [formatStyle]="useShortNumberFormat ? 'short' : 'code'"
                    [maximumFractionDigits]="0"
                    [useMonotypeFont]="false"
                    [value]="tagGroup.marketValueInBaseCurrency"
                ></sb-animated-number>
            </dd>
            <dd class="sb-list-cash text-secondary small">
                <sb-animated-number
                    [ccy]="
                        (useBaseCurrency$ | async)
                            ? (baseCurrency$ | async)
                            : tagGroup.currency
                    "
                    [formatStyle]="useShortNumberFormat ? 'short' : 'code'"
                    [maximumFractionDigits]="0"
                    [useMonotypeFont]="false"
                    [value]="tagGroup.cashInBaseCurrency"
                ></sb-animated-number>
            </dd>
            <div
                class="sb-list-actions sb-list-actions-multiple"
                [class.active]="menuTrigger.menuOpen"
            >
                <tabler-icon name="chevron-right"></tabler-icon>
                <button
                    class="btn btn-link m-n3 p-3 text-primary"
                    [matMenuTriggerFor]="menu"
                    #menuTrigger="matMenuTrigger"
                    (menuOpened)="(menuTrigger.menuOpen)"
                    (menuClosed)="(menuTrigger.menuOpen)"
                    (click)="$event.stopImmediatePropagation(); $event.preventDefault()"
                >
                    <tabler-icon name="dots"></tabler-icon>
                </button>
                <mat-menu #menu="matMenu">
                    <!-- prettier-ignore -->
                    <a
                [routerLink]="[
                                            '/',
                                            'sb-grid',
                                            'portfolio-summary'
                                        ]"
                [queryParams]="{
          accountIds: tagGroup.entities | entityConcat:'accountId',
          tagGroup: tag.group.value, tag: tagGroup.id
        }"
                class="d-flex align-items-center text-reset"
                mat-menu-item
              >
                <tabler-icon
                  class="sb-icon-md me-2"
                  name="arrow-right"
                ></tabler-icon>
                View account
              </a>
                    <a
                        [routerLink]="['/', 'tags']"
                        [queryParams]="{ groupId: tag.group.value, tags: tagGroup.id }"
                        class="d-flex align-items-center text-reset"
                        mat-menu-item
                    >
                        <tabler-icon class="sb-icon-md me-2" name="tags"></tabler-icon>
                        View tag
                    </a>
                </mat-menu>
            </div>
        </a>
    </ng-container>
</ng-template>
<ng-template #legalEntityItem let-legalEntity>
    <ng-container *ngIf="legalEntitiesMap$ | async as legalEntities">
        <a
            [routerLink]="['/', 'sb-grid', 'portfolio-summary']"
            [queryParams]="{
          accountIds: legalEntity.entities | entityConcat:'accountId',
          legalEntityId: legalEntity.id,
        }"
        >
            <sb-company-logo
                size="lg"
                class="sb-list-logo"
                *ngIf="+legalEntity.id | legalEntityLogo$ | async as thumbnail"
                [companyWebsite]="thumbnail.website"
                [companyLogoUrl]="thumbnail.logoUrl"
                [countryCode]="thumbnail.countryCode"
                [type]="thumbnail.icon"
            ></sb-company-logo>
            <dt class="sb-list-name">
                {{
                    legalEntities[+legalEntity.id]?.displayName ||
                        legalEntities[+legalEntity.id]?.shortName ||
                        legalEntities[+legalEntity.id]?.longName ||
                        ('LEGAL_ENTITY_NOT_DEFINED' | translate)
                }}
            </dt>
            <dd class="sb-list-detail text-secondary small">
                {{ legalEntities[+legalEntity.id]?.orgNumber }}
            </dd>
            <dd class="sb-list-balance">
                <sb-animated-number
                    [ccy]="
                        (useBaseCurrency$ | async)
                            ? (baseCurrency$ | async)
                            : legalEntity.currency
                    "
                    [formatStyle]="useShortNumberFormat ? 'short' : 'code'"
                    [maximumFractionDigits]="0"
                    [useMonotypeFont]="false"
                    [value]="legalEntity.marketValueInBaseCurrency"
                ></sb-animated-number>
            </dd>
            <dd class="sb-list-cash text-secondary small">
                <sb-animated-number
                    [ccy]="
                        (useBaseCurrency$ | async)
                            ? (baseCurrency$ | async)
                            : legalEntity.currency
                    "
                    [formatStyle]="useShortNumberFormat ? 'short' : 'code'"
                    [maximumFractionDigits]="0"
                    [useMonotypeFont]="false"
                    [value]="legalEntity.cashInBaseCurrency"
                ></sb-animated-number>
            </dd>
            <div class="sb-list-actions">
                <!--<button class="btn btn-link m-n3 p-3 text-primary">
                <tabler-icon name="dots"></tabler-icon>
            </button>-->
                <tabler-icon name="chevron-right"></tabler-icon>
            </div>
        </a>
    </ng-container>
</ng-template>
<ng-template #accountIssuerItem let-issuer>
    <ng-container *ngIf="accountIssuersMap$ | async as issuers">
        <a
            [routerLink]="['/', 'sb-grid', 'portfolio-summary']"
            [queryParams]="{
          accountIds: issuer.entities | entityConcat:'accountId',
          issuerId: issuer.id,
        }"
        >
            <ng-container
                *ngIf="issuer.id !== 'NON_BANKABLE_ASSETS'; else nonBankableAsset"
            >
                <sb-company-logo
                    size="lg"
                    class="sb-list-logo"
                    *ngIf="null | accountLogo$ : +issuer.id | async as thumbnail"
                    [companyWebsite]="thumbnail.website"
                    [companyLogoUrl]="thumbnail.logoUrl"
                    [countryCode]="thumbnail.countryCode"
                    [type]="thumbnail.icon"
                ></sb-company-logo>
                <dt class="sb-list-name">
                    {{
                        issuers[+issuer.id]?.displayName ||
                            issuers[+issuer.id]?.accountIssuerShortName ||
                            issuers[+issuer.id]?.accountIssuerLongName ||
                            ('ISSUER_NOT_DEFINED' | translate)
                    }}
                </dt>
                <dd class="sb-list-detail text-secondary small">
                    Number of accounts
                    {{ issuer.entities | count : 'accountId' : true }}
                </dd>
            </ng-container>
            <ng-template #nonBankableAsset>
                <sb-company-logo
                    size="lg"
                    class="sb-list-logo"
                    [type]="'BOX'"
                ></sb-company-logo>
                <dt class="sb-list-name">
                    {{ issuer.id | translate }}
                </dt>
                <dd class="sb-list-detail text-secondary small">
                    Number of holdings
                    {{ issuer.entities | count : 'instrument.instrumentId' : true }}
                </dd>
            </ng-template>
            <dd class="sb-list-balance">
                <sb-animated-number
                    [ccy]="
                        (useBaseCurrency$ | async)
                            ? (baseCurrency$ | async)
                            : issuer.currency
                    "
                    [formatStyle]="useShortNumberFormat ? 'short' : 'code'"
                    [maximumFractionDigits]="0"
                    [useMonotypeFont]="false"
                    [value]="issuer.marketValueInBaseCurrency"
                ></sb-animated-number>
            </dd>
            <dd class="sb-list-cash text-secondary small">
                <sb-animated-number
                    [ccy]="
                        (useBaseCurrency$ | async)
                            ? (baseCurrency$ | async)
                            : issuer.currency
                    "
                    [formatStyle]="useShortNumberFormat ? 'short' : 'code'"
                    [maximumFractionDigits]="0"
                    [useMonotypeFont]="false"
                    [value]="issuer.cashInBaseCurrency"
                ></sb-animated-number>
            </dd>
            <div class="sb-list-actions">
                <!--<button class="btn btn-link m-n3 p-3 text-primary">
                <tabler-icon name="dots"></tabler-icon>
            </button>-->
                <tabler-icon name="chevron-right"></tabler-icon>
            </div>
        </a>
    </ng-container>
</ng-template>
<ng-template #accountItem let-account>
    <ng-container *ngIf="accountsMap$ | async as accounts">
        <a
            [routerLink]="['/', 'sb-grid', 'portfolio-summary']"
            [queryParams]="{
          accountIds: account.entities  | entityConcat:'accountId',
        }"
        >
            <ng-container
                *ngIf="account.id !== 'NON_BANKABLE_ASSETS'; else nonBankableAsset"
            >
                <sb-company-logo
                    size="lg"
                    class="sb-list-logo"
                    *ngIf="+account.id | accountLogo$ | async as thumbnail"
                    [companyWebsite]="thumbnail.website"
                    [companyLogoUrl]="thumbnail.logoUrl"
                    [countryCode]="thumbnail.countryCode"
                    [type]="thumbnail.icon"
                ></sb-company-logo>
                <ng-container *ngIf="accounts[+account.id] as accountEntity">
                    <ng-container
                        *ngIf="
                            accountEntity?.accountDisplayName ||
                            accountEntity?.accountClientAlias ||
                            accountEntity?.accountShortName ||
                            'Loading...' as name
                        "
                    >
                        <dt class="sb-list-name">
                            {{ name }}
                        </dt>
                        <dd
                            class="sb-list-detail text-secondary d-flex align-items-center"
                        >
                            <span
                                class="small me-1"
                                *ngIf="
                                    accountEntity?.accountNumber &&
                                    accountEntity.accountNumber !== name
                                "
                            >
                                {{ accountEntity?.accountNumber }}
                            </span>
                            <span
                                class="badge badge-secondary badge-sm my-n1"
                                *ngIf="accountEntity?.accountType as type"
                            >
                                {{ type | translate }}
                            </span>
                        </dd>
                    </ng-container>
                </ng-container>
            </ng-container>
            <ng-template #nonBankableAsset>
                <sb-company-logo
                    size="lg"
                    class="sb-list-logo"
                    [type]="'BOX'"
                ></sb-company-logo>
                <dt class="sb-list-name">
                    {{ account.id | translate }}
                </dt>
                <dd class="sb-list-detail text-secondary small">
                    Number of holdings
                    {{ account.entities | count : 'instrument.instrumentId' : true }}
                </dd>
            </ng-template>
            <dd class="sb-list-balance">
                <sb-animated-number
                    [ccy]="
                        (useBaseCurrency$ | async)
                            ? (baseCurrency$ | async)
                            : account.currency
                    "
                    [formatStyle]="useShortNumberFormat ? 'short' : 'code'"
                    [maximumFractionDigits]="0"
                    [useMonotypeFont]="false"
                    [value]="account.marketValueInBaseCurrency"
                ></sb-animated-number>
            </dd>
            <dd class="sb-list-cash text-secondary small">
                <sb-animated-number
                    [ccy]="
                        (useBaseCurrency$ | async)
                            ? (baseCurrency$ | async)
                            : account.currency
                    "
                    [formatStyle]="useShortNumberFormat ? 'short' : 'code'"
                    [maximumFractionDigits]="0"
                    [useMonotypeFont]="false"
                    [value]="account.cashInBaseCurrency"
                ></sb-animated-number>
            </dd>
            <div
                class="sb-list-actions sb-list-actions-multiple"
                [class.active]="menuTrigger.menuOpen"
            >
                <tabler-icon name="chevron-right"></tabler-icon>
                <button
                    class="btn btn-link m-n3 p-3 text-primary"
                    [matMenuTriggerFor]="menu"
                    #menuTrigger="matMenuTrigger"
                    (menuOpened)="(menuTrigger.menuOpen)"
                    (menuClosed)="(menuTrigger.menuOpen)"
                    (click)="$event.stopImmediatePropagation(); $event.preventDefault()"
                >
                    <tabler-icon name="dots"></tabler-icon>
                </button>
                <mat-menu #menu="matMenu">
                    <!-- prettier-ignore -->
                    <a
                                      [routerLink]="[
                                            '/',
                                            'sb-grid',
                                            'portfolio-summary'
                                        ]"
                                        [queryParams]="{ accountIds: account.id }"
                                      class="d-flex align-items-center text-reset"
                                      mat-menu-item
                                    >
                                        <tabler-icon
                                          class="sb-icon-md me-2"
                                          name="arrow-right"
                                        ></tabler-icon>
                                        View account
                                    </a>
                    <a
                        [routerLink]="['/', 'account-statement']"
                        [queryParams]="{ accountId: account.id }"
                        class="d-flex align-items-center text-reset"
                        mat-menu-item
                        *ngIf="account.id !== 'NON_BANKABLE_ASSETS'"
                    >
                        <tabler-icon
                            class="sb-icon-md me-2"
                            name="file-invoice"
                        ></tabler-icon>
                        View statement
                    </a>
                </mat-menu>
            </div>
        </a>
    </ng-container>
</ng-template>
<ng-template #loadingBalance>
    <span class="sb-account-balance text-nowrap text-muted" aria-busy="true">
        Loading balance...
    </span>
</ng-template>
<ng-template #noAccounts>
    <div
        *ngIf="isLoading$ | async"
        aria-busy="true"
        class="skeleton-loader skeleton-loader-table"
    >
        Loading accounts...
    </div>
    <div *ngIf="!(isLoading$ | async)" role="alert" class="info mt-0">
        <strong>No accounts found!</strong>
        &nbsp; Please try and
        <button
            class="btn link p-0"
            style="font-size: inherit"
            (click)="showFilters = true"
        >
            adjust filters
        </button>
        if applied or contact
        <a href="mailto:clientservice@swimbird.se">clientservice@swimbird.se</a>
        if you need assistance.
    </div>
</ng-template>
<sb-generic-modal
    [options]="settingsModalOptions"
    (modalDismiss)="toggleShowFilters()"
    *ngIf="showFilters"
></sb-generic-modal>
<ng-template #settingsModalTemplate>
    <div class="row gy-3" @fadeInOut>
        <div class="col-6">
            <h4 class="mb-2">Search</h4>

            <mat-form-field appearance="fill">
                <mat-label>Search</mat-label>
                <input matInput [formControl]="searchCtrl" autocomplete="off" />
                <tabler-icon name="search" matSuffix></tabler-icon>
                <mat-hint>Type to filter accounts</mat-hint>
            </mat-form-field>
        </div>
        <div class="col-6">
            <h4 class="mb-2">Sort</h4>
            <form *ngIf="showFilters" @fadeInOut [formGroup]="sortForm">
                <div class="d-flex align-items-start">
                    <mat-form-field appearance="fill" style="min-width: 0">
                        <mat-label>Sort on</mat-label>
                        <mat-select formControlName="sortBy">
                            <mat-option
                                *ngFor="let option of sortByOptions"
                                [value]="option.key"
                            >
                                {{ option.name }}
                            </mat-option>
                        </mat-select>
                        <mat-hint>How to sort accounts</mat-hint>
                    </mat-form-field>
                    <button
                        class="btn btn-sm primary btn-square m-2 me-md-0 pt-2 flex-shrink-0"
                        type="button"
                        [matTooltip]="
                            (sortForm.value.sortByOrder !== 'asc'
                                ? 'Click to sort accounts ascending'
                                : 'Click to sort accounts descending') +
                            ' by ' +
                            sortForm.value.sortBy
                        "
                        (click)="toggleSortOrder()"
                    >
                        <tabler-icon
                            class="sb-icon"
                            [name]="
                                sortForm.value.sortByOrder === 'asc'
                                    ? 'sort-ascending'
                                    : 'sort-descending'
                            "
                        ></tabler-icon>
                    </button>
                </div>
            </form>
        </div>
        <!--<div class="col-12 sb-tag-filters pb-3">
            <h4 class="mb-2">Filter by legal entity</h4>
            <sb-badges
                size="sm"
                allowActive="multiple"
                variant="primary"
                wrap="true"
                [badges]="availableLegalEntities"
                (badgesChange)="filterLegalEntities($event)"
            ></sb-badges>
        </div>-->
        <div class="col-12 sb-tag-filters pb-3">
            <h4 class="mb-2">Filter by issuer</h4>
            <sb-badges
                size="sm"
                allowActive="multiple-not-empty"
                variant="primary"
                [wrap]="true"
                [badges]="availableIssuers$ | async"
                (badgesChange)="filterIssuers($event)"
            ></sb-badges>
        </div>
        <div class="col-12 sb-tag-filters pb-3">
            <h4 class="mb-2">Filter by instrument (BETA)</h4>
            <sb-badges
                size="sm"
                allowActive="multiple-not-empty"
                variant="primary"
                [wrap]="true"
                [badges]="availableInstruments$ | async"
                (badgesChange)="filterInstruments($event)"
            ></sb-badges>
        </div>
    </div>
</ng-template>
